$(document).ready(function(){
			$(window).scroll(function() {
				var scroll = $(window).scrollTop();

				 //>=, not <=
				if (scroll >= 75) {
					//clearHeader, not clearheader - caps H
					$(".website-header").addClass("fixed");
                    $('.spacer-div').show();
                  $('#google_translate_element').hide();
				} else {
					$(".website-header").removeClass("fixed");
                    $('.spacer-div').hide();
                  $('#google_translate_element').show();
				}
			});
            /*$('.ul-one li').hover(function() {
				$('.ul-one li').removeClass('active');
              	$(this).addClass('active');
            });
  			$(".navbar-main-menu > li").mouseover(function() {

                $(this).find('.ul-one li').first().addClass('active');

                }).mouseout(function() {
					$(this).find('.ul-one li').removeClass('active');
                    $(this).find('.ul-one li').first().addClass('active');

                })*/
  
  				$(".has-megamenu").mouseover(function() {
              		$('.carousel-indicators').hide();
             	}).mouseout(function() {
					$('.carousel-indicators').show();
                })
            
            $(".ul-one li").mouseover(function() {
              
				//$('.ul-one > li').removeClass('active');
              	$(this).closest('.ul-one').find('.ul-one-li').removeClass('active');  
              	$(this).addClass('active');

             }).mouseout(function() {
              
				$(this).removeClass('active');
              	//$(this).closest('.ul-one').find('li').removeClass('active');
                $(this).closest('.ul-one').find('.ul-one-li').first().addClass('active');
              
             })
            
            $(".ul-two li").mouseover(function() {
              
				$(this).closest('.ul-two').find('li').removeClass('active');
                $(this).addClass('active');
              
                }).mouseout(function() {
              
					$(this).closest('.ul-two').find('li').removeClass('active');
                    $(this).closest('.ul-two').find('li').first().addClass('active');

             })
            
            $(".ul-three > li").mouseover(function() {
              
				$(this).closest('.ul-three').find('li .ul-four').removeClass('active');
              	$(this).closest('.ul-three').find('.ul-three-a').removeClass('active');
                $(this).find('.ul-four').addClass('active');
              $(this).find('.ul-three-a').addClass('active');
              
                }).mouseout(function() {
              
					$(this).find('.ul-four').removeClass('active');
              		$(this).find('.ul-three-a').removeClass('active');
                    $(this).closest('.ul-three').find('.ul-four').first().addClass('active');
              		$(this).closest('.ul-three').find('.ul-three-a').first().addClass('active');

             })
            
            
            
            $(document).on('click', '.submenu-click.more', function(){
              	//$(this).closest('.collection-box').find('.submenu-menu').toggleClass('active');
              	$(this).closest('.collection-box').find('.submenu-menu').addClass('active');
              	$(this).hide();
              	$(this).closest('.collection-box').find('.submenu-click.less').show();
            })
            
            $(document).on('click', '.submenu-click.less', function(){
              	//$(this).closest('.collection-box').find('.submenu-menu').toggleClass('active');
              	$(this).closest('.collection-box').find('.submenu-menu').removeClass('active');
              	$(this).hide();
              	$(this).closest('.collection-box').find('.submenu-click.more').show();
            })
            
            $(document).on('click', '.input-group-addon.minus', function(){
              var proQ = $(this).closest('.product-quantity').find('.form-control').val();
              if (proQ == 1 ) {
               		console.log('1'); 
              } else {
                proQ--;
                $(this).closest('.product-quantity').find('.form-control').val(proQ);
              }
            })
            
            $(document).on('click', '.input-group-addon.plus', function(){
              var proQ = $(this).closest('.product-quantity').find('.form-control').val();
                proQ++;
                $(this).closest('.product-quantity').find('.form-control').val(proQ);
            })
            
            $(document).on('click', '.faq-q', function(){
              $('.faq-block .faq-a').slideUp();
              $(this).closest('.faq-block').find('.faq-a').slideDown();
            })
            
            $(document).on('click', '.product-details-h', function(){
              $('.product-details-block').removeClass('arrow-up');
              $('.product-details-p').slideUp();
              $(this).closest('.product-details-block').addClass('arrow-up').find('.product-details-p').slideDown();
            })
            
            $(document).on('click', '.bb-mobile-menu-close', function(){
              $('.bb-mobile-menu, .ul-level-2, .ul-level-3, .ul-level-4').removeClass('active');
            })
            
            $(document).on('click', '.bb-mobile-menu-icon', function(){
              $('.bb-mobile-menu').addClass('active');
            })
            
            $(document).on('click', '.li-level-1.has-submenu', function(){
              var mid = $(this).attr('data-id');
              console.log(mid);
              $("#" + mid).addClass('active');
            })
            
            $(document).on('click', '.li-level-2.has-submenu', function(){
              var mid = $(this).attr('data-id');
              console.log(mid);
              $("#" + mid).addClass('active');
            })
            
            $(document).on('click', '.li-level-3.has-submenu', function(){
              var mid = $(this).attr('data-id');
              console.log(mid);
              $("#" + mid).addClass('active');
            })
            
            $(document).on('click', '.bb-mobile-menu-prev-2', function(){
              $(this).closest('.ul-level-2').removeClass('active');
            })
            
            $(document).on('click', '.bb-mobile-menu-prev-3', function(){
              $(this).closest('.ul-level-3').removeClass('active');
            })
            
            $(document).on('click', '.bb-mobile-menu-prev-4', function(){
              $(this).closest('.ul-level-4').removeClass('active');
            })
            
            var dt = new Date();
  			var dayy = dt.getDay();
  			var dtime = dt.getHours();
  			var shipText = '';
            if(dayy == 0) {
              shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p>';
            }
  			if(dayy == 1) {
              if(dtime < 12) {
              	shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Wednesday, if you order before 1:00 PM Tuesday.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';
            	}
            }
  			if(dayy == 2) {
              if(dtime < 12) {
              	shipText = '<h6>Standard Shipping</h6><p>Wednesday, if you order before 1:00 PM.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Thursday, if you order before 1:00 PM Wednesday.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';
            	}
            }
  			if(dayy == 3) {
              if(dtime < 12) {
              	shipText = '<h6>Standard Shipping</h6><p>Thursday, if you order before 1:00 PM.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Friday, if you order before 1:00 PM Thursday.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';
            	}
            }
  			if(dayy == 4) {
              if(dtime < 12) {
              	shipText = '<h6>Standard Shipping</h6><p>Friday, if you order before 1:00 PM.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM Friday.</p>';
            	}
            }
  			if(dayy == 5) {
              if(dtime < 11) {
              	shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p><h6>Weekend Shipping</h6><p>Saturday/Sunday, if you order before 12:00 PM.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p><h6>Weekend Shipping</h6><p>Sunday, if you order before 12:00 PM Saturday.</p>';
            	}
            }
  			if(dayy == 6) {
              if(dtime < 11) {
              	shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p><h6>Weekend Shipping</h6><p>Sunday, if you order before 12:00 PM.</p>';  
              } else {
              shipText = '<h6>Standard Shipping</h6><p>Tuesday, if you order before 1:00 PM Monday.</p><h6>Weekend Shipping</h6><p>Weekend delivery window closed for the week.</p>';
            	}
            }
  			$('#estimated-delivery-text').html(shipText);
            
            
            
			
});